import React, { lazy } from 'react';
import { MapPin, Mail, Phone, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#1A1A1A] py-12 md:py-16 border-t border-white/10" data-id="element-71">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6" data-id="element-72">
        <div className="grid md:grid-cols-4 gap-8 mb-8 md:mb-12" data-id="element-73">
          {/* Logo & Description */}
          <div className="md:col-span-2 text-center md:text-left" data-id="element-74">
            <div className="flex items-center justify-center md:justify-start mb-4" data-id="element-75">
              <img src="https://cdn.magicpatterns.com/uploads/6mzD2cp15fnbC7PyiPtyAe/Logo-Gerfaj_(1).png" alt="GERFAJ - Arquitectura e Ingeniería" className="h-10 md:h-12 w-auto" width="200" height="48" loading="lazy" decoding="async" data-id="element-76" />
            </div>
            <p className="text-[15px] md:text-[17px] text-white/60 font-normal mb-6 max-w-md mx-auto md:mx-0" style={{
            lineHeight: '1.6'
          }} data-id="element-77">
              Arquitectura de alto rendimiento. Transformando espacios con
              diseño innovador y ejecución impecable.
            </p>
            <div className="space-y-3" data-id="element-78">
              <div className="flex items-center justify-center md:justify-start gap-3 text-[15px] md:text-[17px] text-white/60 font-normal" style={{
              lineHeight: '1.6'
            }} data-id="element-79">
                <Mail className="w-4 h-4 text-[#E8621A]" data-id="element-80" />
                <span data-id="element-81">gerfaj.sas@gmail.com</span>
              </div>
              <div className="flex items-center justify-center md:justify-start gap-3 text-[15px] md:text-[17px] text-white/60 font-normal" style={{
              lineHeight: '1.6'
            }} data-id="element-82">
                <Phone className="w-4 h-4 text-[#E8621A]" data-id="element-83" />
                <span data-id="element-84">+57 (318) 243 4499</span>
              </div>
              <a href="https://www.instagram.com/gerfajarquitectura/" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center md:justify-start gap-3 text-[15px] md:text-[17px] text-white/60 hover:text-[#E8621A] font-normal transition-colors" style={{
              lineHeight: '1.6'
            }} data-id="element-85">
                <Instagram className="w-4 h-4 text-[#E8621A]" data-id="element-86" />
                <span data-id="element-87">@gerfajarquitectura</span>
              </a>
            </div>
          </div>

          {/* Locations */}

          {/* Legal Links */}
          
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 md:pt-8 border-t border-white/10" data-id="element-88">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-89">
            <p className="text-[11px] md:text-[12px] text-white/40 font-semibold uppercase text-center md:text-left" style={{
            lineHeight: '1',
            letterSpacing: '0.08em'
          }} data-id="element-90">
              © 2026 GERFAJ S.A.S. Todos los derechos reservados.
            </p>
            <p className="text-[11px] md:text-[12px] text-white/40 font-semibold uppercase text-center md:text-right" style={{
            lineHeight: '1',
            letterSpacing: '0.08em'
          }} data-id="element-91">
              NIT: 901.300.914-2
            </p>
          </div>
        </div>
      </div>
    </footer>;
}